import { module } from 'angular';
import { TransitionBarService } from './transition-bar.service';
import { TransitionBarComponent } from './transition-bar.component';
import { transitionBarRun } from './transition-bar.run';

export const TransitionBarModule = module('app.fetures.transition-bar', [
  'ui.router'
])
  .service(TransitionBarService.name, TransitionBarService)
  .component('transitionBar', TransitionBarComponent)
  .run(transitionBarRun).name;



// WEBPACK FOOTER //
// ./app/ui/transition-bar/transition-bar.module.ts